var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDevelop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "#D8ECFE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_559_852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.626 18.4725L30.2189 13.5283H24.8309L24.4238 18.3285C22.6517 18.6645 20.9993 19.3125 19.5386 20.2246L15.7549 17.0084L11.9474 20.8246L15.0605 24.4967C14.0786 25.9368 13.3602 27.5688 12.9292 29.2969L7.99609 29.7289V35.1291L12.7855 35.5371C13.1208 37.3132 13.7673 38.9693 14.6773 40.4333L11.4684 44.2255L15.276 48.0416L18.9399 44.9215C20.3767 45.9055 22.0051 46.6255 23.7293 47.0576L24.1364 52.0018H29.5245L29.9316 47.2016C31.7037 46.8656 33.356 46.2175 34.8168 45.3055L38.6004 48.5216L42.408 44.7055L39.2949 41.0333C40.2767 39.5933 40.9951 37.9612 41.4262 36.2332",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8042 32.7772C36.8042 38.0814 32.4937 42.4015 27.2014 42.4015C21.9091 42.4015 17.5986 38.0814 17.5986 32.7772C17.5986 27.473 21.9091 23.1528 27.2014 23.1528C32.4937 23.1528 36.8042 27.449 36.8042 32.7772Z",
    fill: "#9AC7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2016 38.7773C30.508 38.7773 33.1884 36.0909 33.1884 32.7771C33.1884 29.4632 30.508 26.7769 27.2016 26.7769C23.8952 26.7769 21.2148 29.4632 21.2148 32.7771C21.2148 36.0909 23.8952 38.7773 27.2016 38.7773Z",
    fill: "white",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.728 15.1604C57.9972 22.2647 54.8122 29.7289 48.2028 33.5451C41.6174 37.3612 33.5712 36.4012 28.0634 31.745C26.7942 24.6407 29.9791 17.1765 36.5885 13.3603C43.1979 9.54418 51.2201 10.5042 56.728 15.1604Z",
    fill: "white",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4387 32.561C36.4693 32.561 33.5717 31.625 31.177 29.9449C30.6741 24.4247 33.428 19.0245 38.2413 16.2404C40.3966 14.9923 42.8631 14.3203 45.3536 14.3203C48.323 14.3203 51.2206 15.2563 53.6153 16.9604C54.1182 22.4806 51.3643 27.8568 46.551 30.6649C44.3718 31.913 41.9292 32.561 39.4387 32.561Z",
    fill: "#C5E1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7283 15.1602L28.9258 31.2408",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0156 31.769L25.8125 33.0411",
    stroke: "#0561FC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6647 11.7524L43.3418 22.4088",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2352 13.4082L34.0742 27.8087",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1425 26.441L43.7734 23.1528",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.491 32.9451L34.458 28.481",
    stroke: "#0561FC",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_559_852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 43,
    fill: "white",
    transform: "translate(7 10)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelop);
export default __webpack_public_path__ + "static/media/develop.de9471d01d16951d884b78259283d6ba.svg";
export { ForwardRef as ReactComponent };